import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CARDTYPE, CARDSTATUS } from '../../model/models/wallet/wallet-card';
import { TranslateService } from '@ngx-translate/core';
import { WalletCardProvider } from '../../providers/wallet/wallet-card';

@Component({
    selector: 'rmt-wallet-card-selection',
    templateUrl: 'rmt-wallet-card-selection.html'
})
export class RmtWalletCardSelectionComponent {
    @Input() cardDetail: any;
    @Input() walletDetails;
    @Input() cardIssuance;
    @Output() selectEmitter: EventEmitter<any> = new EventEmitter();

    cardTitle: string;
    cardText: string;
    cardBtnText;
    isCardBtnDisable: boolean = false;
    imgSrc: string;

    constructor(private translate: TranslateService, private walletCardProvider: WalletCardProvider) {
    }

    ngAfterViewInit() {
        if (this.cardDetail) {
            if(this.cardDetail.CardType === CARDTYPE.PHYSICAL_CARD){
                this.cardTitle = this.translate.instant("page.eWalletPage.prepaidCardIssuancePage.physicalCardTitle");
                this.cardText = this.translate.instant("page.eWalletPage.prepaidCardIssuancePage.physicalCardText");
                this.imgSrc =  "../assets/img/wallet/ria-prepaid-card-physical.svg";
                if(this.walletDetails.CardRequested) this.isCardBtnDisable = true;
            }else{
                this.cardTitle = this.translate.instant("page.eWalletPage.prepaidCardIssuancePage.virtualCardTitle");
                this.cardText = this.translate.instant("page.eWalletPage.prepaidCardIssuancePage.virtualCardText");
                this.imgSrc = "../assets/img/wallet/ria-prepaid-card-virtual.svg";
            }
            if (this.cardIssuance) {
                this.cardBtnText = this.walletCardProvider.setCardButtonText(this.cardDetail, this.walletDetails, false);
            } else {
                this.cardBtnText = this.translate.instant('page.eWalletPage.prepaidCardIssuancePage.soonButton')

            }
        }
    }

    primaryBtn() {
        if (!this.isCardBtnDisable) this.selectEmitter.emit();
    }
}



// WEBPACK FOOTER //
// ./src/components/rmt-wallet-card-selection/rmt-wallet-card-selection.ts